import * as yup from "yup";
/**
 * Правила логина и пароля на странице приглашения. Те же проверки делает сервер
 * (AccessLinks.LoginPattern, RegeneratePasswordCommandHandler.Validator) — здесь они
 * только чтобы подсказать сразу, а не после отправки.
 */

export const loginError = (login: string, min: number, max: number): string | null => {
  if (!login) {
    return "Придумайте логин";
  }

  if (login.length < min || login.length > max) {
    return `Логин: от ${min} до ${max} символов`;
  }

  if (!/^[A-Za-z0-9][A-Za-z0-9._@-]*$/.test(login)) {
    return "Логин: латинские буквы, цифры и знаки . _ - @, начинается с буквы или цифры";
  }

  return null;
};

export const passwordError = (password: string, min: number): string | null => {
  if (!password) {
    return "Придумайте пароль";
  }

  if (password.length < min) {
    return `Пароль: не короче ${min} символов`;
  }

  if (password.length > 128) {
    return "Пароль: не длиннее 128 символов";
  }

  if (!/\d/.test(password) || !/[a-z]/.test(password) || !/[A-Z]/.test(password)) {
    return "Пароль: нужны цифры, строчные и прописные латинские буквы";
  }

  return null;
};

/**
 * Схема формы приглашения — на ней StandardFormInput рисует звёздочки обязательных
 * полей и подсветку ошибок, как в остальных формах приложения
 */
export const inviteSchema = (invite: boolean, loginMin: number, loginMax: number, passwordMin: number) =>
  yup.object().shape({
    login: invite
      ? yup
          .string()
          .label("Логин")
          .required()
          .test("login-rules", "", function (value) {
            const problem = loginError((value ?? "").trim(), loginMin, loginMax);
            return problem ? this.createError({ message: problem }) : true;
          })
      : yup.string().label("Логин").notRequired(),
    password: yup
      .string()
      .label("Пароль")
      .required()
      .test("password-rules", "", function (value) {
        const problem = passwordError(value ?? "", passwordMin);
        return problem ? this.createError({ message: problem }) : true;
      }),
    repeat: yup
      .string()
      .label("Пароль ещё раз")
      .required()
      .oneOf([yup.ref("password")], "Пароли не совпадают"),
  });
